import {Utils, ApiClientCommunication} from 'neo-common';
import {GameModuleResponse} from './GameModuleResponse';
import {GameModuleResponseFactory} from './GameModuleResponseFactory';
import {GameStatus} from '../Types/GameStatus';
import {IBalance} from '../Types/IBalance';
import {ILimit} from '../Types/ILimit';

/**
 * @class GameResponse - Generic response class for all game client api responses.
 */
export class GameResponse extends ApiClientCommunication.ResponseBase {
    /**
     * @property messageId - id of client message
     */
    messageId: number;

    /**
     * @property roundId - game round id
     */
    roundId: number;

    /**
     * @property status - status of game round
     */
    status: GameStatus;

    /**
     * @property balance - balance after request
     */
    balance: IBalance;

    /**
     * @property totalGain - total gain for player's session (total win minus total bet). Can be negative number. Optional
     */
    totalGain: number;

    /**
     * @property totalWin - total current win for game round in cents
     */
    totalWin: number;

    /**
     * @property modules - object containing responses from game modules.
     * Each module will have response set in property named as module key and be of type specific to module.
     */
    modules: Object;

    /**
     * @property limits - Game limits that were exceeded
     */
    limits: Array<ILimit>;

    /**
     * @property customData - custom data object
     */
    customData: any;

    /**
     * @property cfgVersion - Last known game configuration version.
     */
    cfgVersion: number;

    module<TModuleResponse extends GameModuleResponse>(typeName: string): TModuleResponse {
        var moduleData = Utils.isNullOrUndefined(this.modules) ? null : this.modules[typeName];
        return Utils.isNullOrUndefined(moduleData)
            ? null
            : GameModuleResponseFactory.createModuleResponse(typeName, moduleData) as TModuleResponse;
    }

    protected internalValidate(errors: Array<string>): void {
        if (Utils.isNullOrUndefined(this.messageId)) {
            errors.push('Property "messageId" is missing or has null/undefined value!');
        }
        // TODO(psulek) add check of other required properties...
    }
}

// TODO(psulek) messageId - backend type is int64(long) so additional test must be made to test long.max fit into number!


/** WEBPACK FOOTER **
 ** ./Engine/Communication/Game/Responses/GameResponse.ts
 **/